import { render, staticRenderFns } from "./BaseMatrixTable.vue?vue&type=template&id=6449ad2c&scoped=true"
import script from "./BaseMatrixTable.vue?vue&type=script&lang=js"
export * from "./BaseMatrixTable.vue?vue&type=script&lang=js"
import style0 from "./BaseMatrixTable.vue?vue&type=style&index=0&id=6449ad2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449ad2c",
  null
  
)

export default component.exports